/**
 * Error code to user-friendly Spanish message mapping
 *
 * This file maps technical error codes (from Supabase, PostgreSQL, etc.)
 * to user-friendly Spanish messages that can be shown to end users.
 */

export const ERROR_MESSAGES: Record<string, string> = {
  // ============================================================================
  // PostgREST Errors (PGRST*)
  // ============================================================================

  // PGRST1xx - Connection/Server errors
  PGRST100: "Error de conexión con la base de datos. Intente nuevamente.",
  PGRST101: "El servicio está temporalmente no disponible.",
  PGRST102: "No se pudo establecer conexión con el servidor.",

  // PGRST2xx - Request errors
  PGRST200: "Error en la solicitud. Verifique los datos ingresados.",
  PGRST201: "Formato de datos inválido.",
  PGRST202: "Parámetro requerido faltante.",
  PGRST203:
    "Error en la configuración de la base de datos. Contacte al administrador.",
  PGRST204: "Error de conexión con la base de datos. Intente nuevamente.",

  // PGRST3xx - Authentication/Authorization errors
  PGRST301: "No autorizado. Inicie sesión nuevamente.",
  PGRST302: "No tiene permisos para esta acción.",

  // ============================================================================
  // PostgreSQL Constraint Errors (23xxx)
  // ============================================================================

  // Unique violation
  "23505": "Este registro ya existe.",

  // Foreign key violation
  "23503": "No se puede eliminar porque tiene datos relacionados.",

  // Not null violation
  "23502": "Falta información requerida.",

  // Check violation
  "23514": "Los datos no cumplen con las reglas de validación.",

  // Exclusion violation
  "23P01": "El valor ingresado ya existe y no puede duplicarse.",

  // ============================================================================
  // PostgreSQL Data Errors (22xxx)
  // ============================================================================

  // Invalid text representation
  "22P02": "Formato de datos inválido.",

  // Numeric value out of range
  "22003": "El valor numérico está fuera de rango.",

  // Division by zero
  "22012": "Error en el cálculo (división por cero).",

  // Invalid datetime format
  "22007": "Formato de fecha/hora inválido.",

  // ============================================================================
  // PostgreSQL Access Errors (42xxx)
  // ============================================================================

  // Undefined table
  "42P01": "Tabla no encontrada. Contacte al administrador.",

  // Undefined column
  "42703": "Columna no encontrada. Contacte al administrador.",

  // Undefined function
  "42883": "Función no encontrada. Contacte al administrador.",

  // ============================================================================
  // Network Errors
  // ============================================================================

  NETWORK_ERROR: "Error de conexión. Verifique su internet.",
  TIMEOUT: "La operación tardó demasiado. Intente nuevamente.",
  CORS_ERROR: "Error de seguridad. Contacte al administrador.",

  // ============================================================================
  // Authentication Errors
  // ============================================================================

  AUTH_SESSION_EXPIRED: "Su sesión ha expirado. Inicie sesión nuevamente.",
  AUTH_INVALID_CREDENTIALS: "Credenciales inválidas.",
  AUTH_USER_NOT_FOUND: "Usuario no encontrado.",
  AUTH_WEAK_PASSWORD: "La contraseña debe ser más fuerte.",
  AUTH_EMAIL_NOT_CONFIRMED: "Confirme su correo electrónico.",

  // ============================================================================
  // Default/Unknown Errors
  // ============================================================================

  UNKNOWN: "Ocurrió un error inesperado. Intente nuevamente.",
};

/**
 * Get error message by code with fallback
 */
export function getErrorMessageByCode(code: string | null): string {
  if (!code) return ERROR_MESSAGES.UNKNOWN;
  return ERROR_MESSAGES[code] || ERROR_MESSAGES.UNKNOWN;
}
